import React from 'react';
import classes from './PeopleIcon.module.css';

/* eslint-disable max-len */

const peopleIcon = (props) => {
  return (
    <svg
      className={[classes.OuterSVG, classes[props.type]].join(' ')}
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__Group_3419"
      width="21.488"
      height="21.152"
      data-name="Group 3419"
      viewBox="0 0 21.488 21.152"
    >
      <path
        stroke={props.fillColor ? props.fillColor : '#d2d5d6'}
        id="prefix__user-alt"
        d="M3 3.373a1.686 1.686 0 1 0-1.688-1.687A1.687 1.687 0 0 0 3 3.373zm1.5.375h-.648a2.038 2.038 0 0 1-1.707 0H1.5A1.5 1.5 0 0 0 0 5.246v.187A.562.562 0 0 0 .562 6h4.872A.562.562 0 0 0 6 5.434v-.188a1.5 1.5 0 0 0-1.5-1.499z"
      />
      <path
        stroke={props.fillColor ? props.fillColor : '#d2d5d6'}
        id="prefix__user-alt-2"
        d="M3 3.373a1.686 1.686 0 1 0-1.688-1.687A1.687 1.687 0 0 0 3 3.373zm1.5.375h-.648a2.038 2.038 0 0 1-1.707 0H1.5A1.5 1.5 0 0 0 0 5.246v.187A.562.562 0 0 0 .562 6h4.872A.562.562 0 0 0 6 5.434v-.188a1.5 1.5 0 0 0-1.5-1.499z"
        data-name="user-alt"
        transform="translate(7.746)"
      />
      <path
        stroke={props.fillColor ? props.fillColor : '#d2d5d6'}
        id="prefix__user-alt-3"
        d="M3 3.373a1.686 1.686 0 1 0-1.688-1.687A1.687 1.687 0 0 0 3 3.373zm1.5.375h-.648a2.038 2.038 0 0 1-1.707 0H1.5A1.5 1.5 0 0 0 0 5.246v.187A.562.562 0 0 0 .562 6h4.872A.562.562 0 0 0 6 5.434v-.188a1.5 1.5 0 0 0-1.5-1.499z"
        data-name="user-alt"
        transform="translate(15.492)"
        className={classes.SubPath1}
      />
      <path
        id="prefix__Path_3877"
        d="M0 0v11"
        stroke={props.fillColor ? props.fillColor : '#d2d5d6'}
        className={classes.SubPath1}
        data-name="Path 3877"
        transform="translate(2.951 9.152)"
      />
      <path
        id="prefix__Path_3878"
        d="M0 0v11"
        stroke={props.fillColor ? props.fillColor : '#d2d5d6'}
        data-name="Path 3878"
        className={classes.SubPath2}
        transform="translate(10.852 9.152)"
      />
      <path
        id="prefix__Path_3879"
        d="M0 0v11"
        stroke={props.fillColor ? props.fillColor : '#d2d5d6'}
        className={classes.SubPath2}
        data-name="Path 3879"
        transform="translate(18.754 9.152)"
      />
    </svg>
  );
};

export default peopleIcon;
